var _image, _image2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.07,
    height: 48.07,
    viewBox: "0 0 1900 1900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 1900,
    height: 1900,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAcElEQVRoge3asQ2AMBAEwcMipf8KoQEXALJTClidtBN+9JvfkeROcqXTXAFv6fPbWBW/a485ip/fDKAZQDOAZgDNAJoBNANoBtAMoBlAM4BmAM0AmgE0A2gG0AygGUAzgGYAzQBa/djjTPLUzm2S+QE9WQgP+ead8QAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 2,
    y: 2,
    width: 1896,
    height: 1896,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABsklEQVRoge2ay0rDQBhGT4sgCip2JyiouPCycCfiA/gWLlzoRgT3voQ7fQFB36O+QgXFnRdwUaXxUl04Mm0ktb8NSfPXYWAODIQz00y+JjOZJi0ZY+6AMfwksgGMpwffomxTCOsPUdnjg28RArjG+wBDwuhyCVSBG6ABfHXtfRE4KNKjnUYbA7gP1IE94EzU/GY+Dtcv0SDOgP1CVoFbUSOZEyYngxgDuxkPXgXtAA/AubC9+exZkxHtAFVh0mmm1mZAewzUhUmoAEfAQoebEK1yoh0gbX87wJawBdG+hErCJIwK41mAD2EU0A4wJUxCRRgF0q7ZrJwAtbhtLeUzp8B1l1sB9kXLHGgsJZbjNU8/bAAXBfpW+UEzK0x21ot27no5PS1MTjQCPAuTncIBNAbxDHAVb9up8kW0aDPyx71gSbTKix3EphhNY8xbXI7tU5oe5bCj3U8pSkPjDAx3bE+K2oTx+Cyooj2IX4VJeBdGgfBUwjUhgGtCANeEAK4JAVwTArhGO8CTMAmPwiig/WRuDdgWts2mMAoM6gXHfxFeszonBHCN93/2sNPovbezEETfyDL7HXRt11kAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3db30bf6a60c44566398e3b28598d3c1.svg";
export { ForwardRef as ReactComponent };